import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import "./Header.css";
import { useDispatch } from 'react-redux';
import { handleFiles } from "../../utils/helpers";
import { InputRef } from "../../utils/typesAndMaps";
import { ajaxGetVersion } from "../../api";

interface HeaderProps {
  loadingRef: InputRef
}

export default function Header({ loadingRef }: HeaderProps) {
  const iptRef: InputRef = useRef(null);
  const [version, setVersion] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    ajaxGetVersion().then((res: { success: boolean, version?: string }) => {
      const version = res.version;
      if (version) {
        const _version = version.split(".").slice(0, 3).join(".");
        setVersion(`(ver. ${_version})`);
      } else {
        setVersion(`(ver. 10)`);
      }
    })
  }, [])

  const triggerIpt = () => {
    iptRef.current!.click();
  }

  const handleIptChange = async (e: ChangeEvent<HTMLInputElement>) => {
    handleFiles(e.target.files as unknown as File[], loadingRef, dispatch);
    iptRef.current!.value = "";
  }

  return (
    <div className="dbr-header">
      <a className="dbr-header-left" target="_blank" rel="noreferrer" href="https://www.dynamsoft.com/barcode-reader/overview/">
        <img src={require("../../assets/image/dbr-logo-32x32.png")} alt="logo" />
        <h1>Dynamsoft Barcode Reader <span className="dbr-version-number">{version}</span></h1>
        <h1>online-demo {version}</h1>
      </a>
      <div className="dbr-header-right">
        <a className="dbr-download-btn" target="_blank" rel="noreferrer" href="https://www.dynamsoft.com/barcode-reader/downloads/#desktop">DOWNLOAD THE SDK</a>
        <div className="dbr-input" onClick={triggerIpt}>
          <input type="file" style={{ display: "none" }} accept="image/bmp,image/gif,image/jpeg,image/png,image/webp,application/pdf,image/tiff" multiple ref={iptRef} onChange={handleIptChange} />
          <svg height="22" viewBox="0 0 30 24" xmlns="http://www.w3.org/2000/svg"><path fill="#818E94" d="M4285,223h-12l-3-3h-9a2.992,2.992,0,0,0-2.98,3L4258,241a3.009,3.009,0,0,0,3,3h24a3.009,3.009,0,0,0,3-3V226A3.009,3.009,0,0,0,4285,223Zm-4,17h-2v-6h-3l4-5,4,5h-3v6Z" transform="translate(-4258 -220)"></path></svg>
        </div>
      </div>
    </div>
  );
}